import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../data/translations';
import { Check, ArrowUpRight } from 'lucide-react';

const ForCompaniesSection = () => {
  const { lang } = useLang();
  const cs = t.forCompanies.caseStudy;

  return (
    <section id="for-companies" data-testid="for-companies-section" className="relative py-24 md:py-32 bg-[#0F172A] grain-overlay">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Header */}
        <div className="mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] font-['Manrope'] mb-4">
            {t.forCompanies.overline[lang]}
          </span>
          <h2
            data-testid="for-companies-title"
            className="font-['Outfit'] text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight max-w-2xl"
          >
            {t.forCompanies.title[lang]}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Benefits */}
          <div>
            <div className="flex flex-col gap-5">
              {t.forCompanies.benefits.map((b, i) => (
                <div key={i} data-testid={`benefit-${i}`} className="flex items-start gap-4 group">
                  <div className="w-6 h-6 flex items-center justify-center border border-[#334155] group-hover:border-[#2563EB] mt-0.5 flex-shrink-0 transition-colors">
                    <Check className="w-3.5 h-3.5 text-[#2563EB]" strokeWidth={2} />
                  </div>
                  <span className="font-['Manrope'] text-base md:text-lg text-[#CBD5E1] group-hover:text-white transition-colors">
                    {b[lang]}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Case Study */}
          <div className="border border-[#334155] p-8 md:p-10">
            <div className="flex items-center gap-2 mb-4">
              <ArrowUpRight className="w-4 h-4 text-[#2563EB]" strokeWidth={1.5} />
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] font-['Manrope']">
                {cs.title[lang]}
              </span>
            </div>

            <h3 className="font-['Outfit'] text-xl md:text-2xl font-semibold text-white mb-4 tracking-tight">
              {cs.company[lang]}
            </h3>
            <p className="font-['Manrope'] text-sm text-[#94A3B8] leading-relaxed mb-8">
              {cs.desc[lang]}
            </p>

            {/* Metrics Grid */}
            <div className="grid grid-cols-2 gap-6">
              {cs.metrics.map((m, i) => (
                <div key={i} data-testid={`metric-${i}`}>
                  <div className="font-['Outfit'] text-3xl md:text-4xl font-black text-[#2563EB] mb-1">
                    {m.value}
                  </div>
                  <div className="font-['Manrope'] text-xs text-[#94A3B8] leading-snug">
                    {m.label[lang]}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForCompaniesSection;
